import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    List,
    ListItem,
    ListItemText,
    Alert,
    Divider
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';

const BulkCopyResultDialog = ({ open, onClose, result }) => {
    if (!result) return null;

    const { succeeded = [], skipped = [], failed = [] } = result;
    const total = succeeded.length + skipped.length + failed.length;
    const hasIssues = skipped.length > 0 || failed.length > 0;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                Bulk Copy Results
            </DialogTitle>
            <DialogContent>
                <Box sx={{ mb: 2 }}>
                    <Alert severity={hasIssues ? 'warning' : 'success'} sx={{ mb: 2 }}>
                        <Typography variant="body1">
                            Successfully copied {succeeded.length} of {total} frame{total > 1 ? 's' : ''}
                        </Typography>
                    </Alert>
                </Box>

                {succeeded.length > 0 && (
                    <Box sx={{ mb: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <CheckCircleIcon color="success" sx={{ mr: 1 }} />
                            <Typography variant="h6">
                                Copied ({succeeded.length})
                            </Typography>
                        </Box>
                        <Typography variant="body2" color="text.secondary">
                            {succeeded.length} frame{succeeded.length > 1 ? 's' : ''} successfully added to your catalog
                        </Typography>
                    </Box>
                )}

                {skipped.length > 0 && (
                    <Box sx={{ mb: 2 }}>
                        <Divider sx={{ my: 2 }} />
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <WarningIcon color="warning" sx={{ mr: 1 }} />
                            <Typography variant="h6">
                                Skipped ({skipped.length})
                            </Typography>
                        </Box>
                        <List dense>
                            {skipped.map((item, idx) => (
                                <ListItem key={idx} sx={{ pl: 0 }}>
                                    <ListItemText
                                        primary={item.modelNumber || `Frame ID: ${item.id}`}
                                        secondary={item.reason}
                                        primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }}
                                        secondaryTypographyProps={{ variant: 'caption' }}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                )}

                {failed.length > 0 && (
                    <Box>
                        <Divider sx={{ my: 2 }} />
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <ErrorIcon color="error" sx={{ mr: 1 }} />
                            <Typography variant="h6">
                                Failed ({failed.length})
                            </Typography>
                        </Box>
                        <List dense>
                            {failed.map((item, idx) => (
                                <ListItem key={idx} sx={{ pl: 0 }}>
                                    <ListItemText
                                        primary={item.modelNumber || `Frame ID: ${item.id}`}
                                        secondary={item.reason}
                                        primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }}
                                        secondaryTypographyProps={{ variant: 'caption', color: 'error' }}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BulkCopyResultDialog;
